import { User } from "@/types/users"
import { getServerOrClientCookies } from "./cookies"
import { setUser } from "@sentry/nextjs"

/**
 * Identifies the currently logged-in user, given their userID.
 */
function identifySentryUserId(userId?: string) {
  if (!userId) {
    return
  }
  setUser({ id: userId })
}

/**
 * Identifies the currently logged-in user, given their userID.
 */
export async function identifySentryByCookies() {
  const userId = await getServerOrClientCookies("userId")
  identifySentryUserId(userId)
}

/**
 * Identifies the currently logged-in user, given their user object.
 */
export function identifySentryUser(user: User) {
  setUser({
    id: user.id,
    email: "email" in user ? user.email : undefined,
    wallet_address: "wallet_address" in user ? user.wallet_address : undefined,
  })
}

export function identifySentryWallet(walletAddress: string) {
  setUser({ wallet_address: walletAddress })
}
